(function () {'use strict';}());
angular.module('elidb').service('ELIService', function($http,$window)
{
	var trace = angular.trace;
	var self = {};
	self.tech = {};
	self.resources = [];
	self.tags = [];
	self.tagLookup = {};
	self.tagListing = [];
	self.tagDictionary = {};
	self.latitude = 0;
	self.longitude = 0;
	self.categoryLookup = {};
	self.categories = [];
	self.identity = [];
	self.zip = [];
	self.radius = [];
	self.utags = [];
	self.ctags = [];
	self.ipaddress = [];
	self.city = [];
	self.details = [];
	self.tstate = window.location.href.match(/la[\-\.]/i) ? "LA" : "MA";

	self.lastRequestedRadius = null;

	self.initialize = function(){
		trace(self.tstate, window.location.href);
		return $http.post(__DIR__+'/php/scripts/ELIService.php',{request:"initialize", tstate: self.tstate,lang:__LANG__}).success(onInitializeSuccess).error(onServerError);
	};
	self.submitResource = function(data) {
		return $http.post(__DIR__+'/php/scripts/ELIService.php',{request:"submit",name:data.name, email: data.email, details: data.details,lang:__LANG__});
	};
	self.generateSearch = function(data) {
		return $http.post(__DIR__+'/php/scripts/AnalyticsService.php',{request:"saveSearch",data:data,lang:__LANG__});
	};
	self.submitUserEvent = function(data) {
		return $http.post(__DIR__+'/php/scripts/AnalyticsService.php',{request:"saveUserEvent",data:data,lang:__LANG__});
	};

	self.submitResourceView = function(search,resource) {
		return $http.post(__DIR__+'/php/scripts/AnalyticsService.php',{request:"saveView",search:search, resource: resource,lang:__LANG__});
	};
	self.submitForm = function(data) {
		var d = new Date();
	    d.setTime(d.getTime() + (3650*24*60*60*1000));
	    var expires = "expires="+ d.toUTCString();
		document.cookie = "surveycomplete=true;" + expires + ";path=/";
		return $http.post(__DIR__+'/php/scripts/ELIService.php',{request:"survey",data:data,lang:__LANG__});
	};
	self.fetchResourcesForZip = function(zip,radius,browserLat,browserLong,useBrowserCoords){
		self.lastRequestedRadius = radius;
		return $http.post(__DIR__+'/php/scripts/FetchResources.php',{request:"fetchResources", tstate: self.tstate, zip:zip,radius:radius,browserLat:browserLat,browserLong:browserLong,userBrowserCoords:useBrowserCoords ? true : false,lang:__LANG__}).success(onFetchSuccess).error(onServerError);
	};
	self.checkURL = function(){
		
		if(window.GET.id) {
			self.identity = [0,window.GET.id];
			getResource();
			return;
		}

		if(!window.location.hash) {
			return;
		}

		self.identity = window.location.hash.match(/id=([0-9]+)/);
		self.zip = window.location.hash.match(/zip=([0-9]+)/);
		self.radius = window.location.hash.match(/radius=([0-9]+)/);
		self.utags = window.location.hash.match(/tags=(.*)/);

		if(self.identity !== null){
			getResource();
		}
	};

	self.createLocationSpecificLink = function(data){
		return $http.post(__DIR__+'/php/scripts/ELIService.php',{request:"locationLink", search: data,lang:__LANG__}).error(onServerError);
	};

	self.createUserSpecificLink = function(data){
		return $http.post(__DIR__+'/php/scripts/ELIService.php',{request:"userLink", search: data,lang:__LANG__}).error(onServerError);
	};

	self.gtag = function(page, lang, state) {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event': 'RD Page View',
			'pagePath': window.location.href,
			'pageTitle': page,
			'language': lang,
			'state': state
		});

		trace(window.dataLayer);
	};

	function getResource(){
		return $http.post(__DIR__+'/php/scripts/ELIService.php',{request:"getId", id:self.identity[1],lang:__LANG__}).success(onFetchSuccess).error(onServerError);
	}

	function getZip(){
		return $http.post(__DIR__+'/php/scripts/ELIService.php',{request:"getIpAddress",lang:__LANG__}).success(onGetIp).error(onServerError);
	}
	
	function onGetIp(data){
		self.ipaddress = data.ipaddress;
		self.city = data.city;
		self.zip = data.postal;
		self.latitude = data.location.match(/^(.*),/);
		self.longitude = data.location.match(/,(.*)$/);
		self.details = data.details;

		if(self.zip === null){
			var geocoder = new google.maps.Geocoder();
			var latlng = new google.maps.LatLng(self.latitude, self.longitude);
			geocoder.geocode({'latLng': latlng}, function(results, status){
//				trace("step 1");
				if (status === google.maps.GeocoderStatus.OK) {
					trace("step 2");
      		if (results[0]) {
      			//trace("step 3");
    	    	for (var i = 0; i < results[0].address_components.length; i++) {
    	    		//trace("step 4");
  	        	var types = results[0].address_components[i].types;
	            for (var typeIdx = 0; typeIdx < types.length; typeIdx++) {
	            	//trace("step 5");
            	  if (types[typeIdx] == 'postal_code') {
            	  	//trace("step 6");
          	      //trace(results[0].address_components[i].long_name);
        	        //trace(results[0].address_components[i].short_name);
        	        self.zip = results[0].address_components[i].short_name;
      	        }
    	        }
		        }
	        } else {
          	//trace("No results found");
      		}
    		} else{
    			self.zip = null;
    		}
			});
		}
	}

	function onFetchSuccess(data)
	{
		trace("on fs", data);
		self.resources = data.resources;
		self.latitude = data.latitude;
		self.longitude = data.longitude;
		self.resourceDependencies = generateResourceDependencies(data);
		if(data.status === "error") $window.alert(data.message);

		self.resources.sort(function(a,b) {
			if(a.distance > b.distance) return 1;
			if(a.distance < b.distance) return -1;
			if(a.name > b.name) return 1;
			if(a.name < b.name) return -1;
			return 0;
		});
	}

	self.markFirstStatewideResource = function(resources, radius) {

		resources.forEach(function(e){
			e.isFirstStatewide = false;
		});

		for(var i = 0, count = resources.length; i < count; i++) {
			var resource = resources[i];
			if(resource.distance > radius) {
				resource.isFirstStatewide = true;
				break;
			}
		}
	};

	function generateResourceDependencies(data) {
		var lookup = {};
		if(!data.resource_dependencies) return lookup;

		for(var i = 0, count = data.resource_dependencies.length; i < count; i++) {
			var dep = data.resource_dependencies[i];
			if(!lookup[dep.resourceID]) lookup[dep.resourceID] = [];
			lookup[dep.resourceID].push(dep);
		}

		return lookup;
	}

	function onInitializeSuccess(data)
	{
//		trace(data);
		self.tech = data.tech;
		self.tagLookup = data.tags;
		self.tagDependencies = data.tag_dependencies;
		self.resourceRequirements = data.resource_requirements;

		for(var prop in data.tags)
		{
			self.tagListing.push(data.tags[prop]);

			var listing = data.tags[prop];
			for(var i = 0, count = listing.length; i < count; i++)
			{
				listing[i].selected = false;
				self.tags.push(listing[i]);
				self.tagDictionary[listing[i].id] = listing[i];
			}
		}

		self.filts = {};

		self.filts.Age = self.tech.txtFiltCAge.value;
		self.filts.Diagnosis = self.tech.txtFiltCDiagnosis.value;
		self.filts.Custom = self.tech.txtFiltCCustom.value;
		self.filts.Service = self.tech.txtFiltCService.value;
		self.filts.Therapy = self.tech.txtFiltCTherapy.value;
		self.filts["Medical & Evaluation Services"] = self.tech.txtFiltCMedical.value;
		self.filts["Education & Employment"] = self.tech.txtFiltCEdu.value;
		self.filts["Adult Programs & Services"] = self.tech.txtFiltCAdult.value;
		self.filts["Parent & Caregiver Support"] = self.tech.txtFiltCParent.value;
		self.filts.Legal = self.tech.txtFiltCLegal.value;
		self.filts["Social & Recreational Activities"] = self.tech.txtFiltCSocial.value;
		self.filts.Other = self.tech.txtFiltCOther.value;

		self.categories = assembleSearchHierarchy();


		self.tagListing.sort(function(a,b){
			if(a[0].type > b[0].type) return 1;
			if(a[0].type < b[0].type) return -1;
			return 0;
		});

//		trace(self);

	}

	function onServerError(data)
	{
		trace("server error",data);
	}

	function assembleSearchHierarchy()
	{
		var tags = self.tags.concat();
		tags.sort(function(a,b){
			if(a.type > b.type) return 1;
			if(a.type < b.type) return -1;
			if(a.subtype && b.subtype && a.subtype > b.subtype) return 1;
			if(a.subtype && b.subtype && a.subtype < b.subtype) return -1;
			if(a.type === "Age" && a.id > b.id) return 1;
			if(a.type === "Age" && a.id < b.id) return -1;
			if(a.label > b.label) return 1;
			if(a.label < b.label) return -1;
			return 0;
		});


		var categories = [];
		var currentCategory,currentSub;
		var lastTag;
		var i,count;
		var labelLookup = {"Therapy" : "txtFiltCTherapy",
		"Medical & Evaluation Services" : "txtFiltCMedical",
		"Education & Employment" : "txtFiltCEdu",
		"Adult Programs & Services" : "txtFiltCAdult",
		"Parent & Caregiver Support" : "txtFiltCParent",
		"Legal" : "txtFiltCLegal",
		"Social & Recreational Activities" : "txtFiltCSocial",
		"Other" : "txtFiltCOther"
		};

		trace(tags);

		for(i = 0, count = tags.length; i < count; i++)
		{
			var tag = tags[i];
			if(!currentCategory || lastTag.type !== tag.type) 
			{
				currentCategory = {label:tag.type,subs:[]};
				categories.push(currentCategory);
				self.categoryLookup[tag.type] = currentCategory;
				currentSub = null;
				if(tag.type === "Custom") currentCategory.label = "MassHealth";
			}
			if(!currentSub || lastTag.subtype !== tag.subtype)
			{
				var labelInfo = labelLookup[tag.subtype];
				var profileLabel = tag.subtype;
				if(labelInfo && self.tech[labelInfo]) profileLabel = self.tech[labelInfo].value;
				currentSub = {label:tag.subtype || tag.type, profileLabel: profileLabel,tags: []};
				currentCategory.subs.push(currentSub);
			}
			currentSub.tags.push(tag);
			lastTag = tag;
		}

		for(i = 0, count = categories.length; i < count; i++)
		{
			var category = categories[i];
			if(category.subs.length === 1) category.flat = true;
			category.subs.sort(function(a,b){
				if(a.tags.length > b.tags.length) return -1;
				if(a.tags.length < b.tags.length) return 1;
				if(a.label > b.label) return 1;
				if(a.label < b.label) return -1;
				return 0;
			});
		}

		categories.sort(function(a,b){
			if(!a.flat && b.flat) return -1;
			if(a.flat && !b.flat) return 1;
			if(a.label > b.label) return 1;
			if(a.label < b.label) return -1;
			return 0;
		});

		return categories;
	}

	return self;
});